import asyncFetch from '../utils/asyncFetch';

const getLogs = async (token, user) => {
  try {
    const result = await asyncFetch(
      `${process.env.REACT_APP_BACKEND_URL}/user-logs?user=${user.id}&_sort=created_at:DESC`,
      { method: 'GET', headers: { Authorization: `Bearer ${token}` } },
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export default getLogs;
